"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOrUpdateTranslationDto = void 0;
class CreateOrUpdateTranslationDto {
    key;
    translations;
}
exports.CreateOrUpdateTranslationDto = CreateOrUpdateTranslationDto;
